import Vue from 'vue'
import helper from '@/plugins/helper'
import App from '@/App.vue'
import '@/plugins/vuetify'
import '@/components'
import firebase from 'firebase'

Vue.config.productionTip = false
Vue.use(helper)

const firebaseConfig = {
    apiKey: "AIzaSyBfcfu9UXTfR5HQxjwEAnTrVLtU1epzSaA",
    authDomain: "sashin-agrawal.firebaseapp.com",
    databaseURL: "https://sashin-agrawal.firebaseio.com",
    projectId: "sashin-agrawal",
    storageBucket: "sashin-agrawal.appspot.com",
    messagingSenderId: "682711393225",
    appId: "1:682711393225:web:975c80dd8c160fa1823e18",
    measurementId: "G-V3P4CXKFMF"
  }; 
firebase.initializeApp(firebaseConfig);

new Vue({ render: (h) => h(App) }).$mount('#app')
